module.exports = __webpack_public_path__ + "static/media/idea.5fdaed69.svg";